import { actions } from  '../constants';
import store from '../store';
import { remoteCall } from '../lib';

function loadingPatients() {
  return {
    type: actions.PATIENT_LIST_REQUESTED,
    payload: {}
  };
}

function loadingPatientsFailed(error) {
  return {
    type: actions.PATIENT_LIST_REQUEST_FAILED,
    payload: {
      error
    }
  };
}

function patientsLoaded(patients) {
  return {
    type: actions.PATIENT_LIST_RECEIVED,
    payload: {
      patients
    }
  };
}

export function loadPatients(){
  return (dispatch) => {
    dispatch(loadingPatients());
    remoteCall('patients', 'patients').then((patients) =>{      
      dispatch(patientsLoaded(patients));
    }).catch((err) => {
      dispatch(loadingPatientsFailed(err));
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/patient-list.js